import PropTypes from "prop-types";

/**
 * PropTypes for AppContent component
 *
 * @property {string} [className] - Additional CSS classes
 */
export const appContentPropTypes = {
  className: PropTypes.string,
};
